module.exports = __webpack_public_path__ + "img/gg_fishing.6fc95bc5.png";